import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getMiddlewareSocketInstance from './common/SocketMiddleware';

const apiCaller = getApiInstance();

export function initEnvironment() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            return apiCaller
                .call(api.initEnvironment())
                .then(({ data }) => {
                    if (!data.success) reject(new Error('testbench.initEnv.failed'));

                    let access_token = localStorage.getItem('access_token');
                    if (access_token) access_token = access_token.replace(/"/g, '');

                    /** Middleware Connection **/
                    if (typeof data.middlewaresConfig !== 'undefined') {
                        const socketConnexion = getMiddlewareSocketInstance(dispatch, getState, access_token, data.middlewaresConfig);
                        if (!socketConnexion) reject(new Error('testbench.messages.failedInitMiddle'));
                    }
                    if (typeof data.packs !== 'undefined')
                        dispatch({
                            type: 'TESTBENCH__SET_PACKS_CONFIG',
                            packs: data.packs
                        });
                    resolve();
                })
                .catch(error => {
                    Logger.error('dataActions: initEnvironmentTestBench - ', error);
                    reject(new Error(`api.message.${error.message}`));
                });
        });
    };
}

export function disconnectEnvironment() {
    return dispatch => {
        const middlewareInstance = getMiddlewareSocketInstance();
        if (middlewareInstance) middlewareInstance.destroy();
        dispatch({
            type: 'RESET_STORE'
        });
    };
}



// WEBPACK FOOTER //
// ./environments/testbench/actions.js